exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-07910fe0]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-07910fe0]{display:none !important}}[data-v-07910fe0] .sf-bar__icon *[role=button]{cursor:pointer}\n", ""]);

// exports
